import { SequenceManagerAction } from '../actions/SequenceManagerAction';
import { simSwapSendOtp, simSwapValidateOtp, simSwapResendOtp } from "../api/api";

const SIMSwapOTPVerificationAction = {
    OTP_VERIFICATION_VALUE : 'OTP_VERIFICATION_VALUE',
    SIMSWAP_OTP_INITIATE_SUCCESS : 'SIMSWAP_OTP_INITIATE_SUCCESS',
    SIMSWAP_OTP_VALIDATE_SUCCESS : 'SIMSWAP_OTP_VALIDATE_SUCCESS',
    SIMSWAP_OTP_RSEND_SUCCESS : 'SIMSWAP_OTP_RSEND_SUCCESS',
} as const;

const OTPVerificationValue = (otp: any, offerContainerId: any) => {
    return function (dispatch: any) {
        dispatch({ type: SIMSwapOTPVerificationAction.OTP_VERIFICATION_VALUE, payload: { otp: otp, offerContainerId: offerContainerId } });
        dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['SIMSwapOTPVerification'] });
    }
}

const OTPInitiate = (msisdn: any, modId: any, email: any, verifyValue: any, date: any, lang: any, otpLength: any, isNumeric: any) => {
    return function (dispatch: any) {
        simSwapSendOtp(msisdn, modId, email, verifyValue, date, lang, otpLength, isNumeric).then((response) => {
            dispatch({ type: SIMSwapOTPVerificationAction.SIMSWAP_OTP_INITIATE_SUCCESS, payload: response });
        })
            .catch((error) => {
                //Display error
                if (error?.response) {
                    dispatch({ type: SIMSwapOTPVerificationAction.SIMSWAP_OTP_INITIATE_SUCCESS, payload: error.response });
                } else {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                }
            })
    }
}

const OTPValidate = (otp: any, hashCode: any) => {
    return function (dispatch: any) {
        simSwapValidateOtp(otp, hashCode).then((response) => {
            dispatch({ type: SIMSwapOTPVerificationAction.SIMSWAP_OTP_VALIDATE_SUCCESS, payload: response });
        })
            .catch((error) => {
                //Display error
                if (error?.response) {
                    dispatch({ type: SIMSwapOTPVerificationAction.SIMSWAP_OTP_VALIDATE_SUCCESS, payload: error?.response });
                } else {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                }
            })
    }
}

const OTPResend = (hashCode: any, verification: any) => {
    return function (dispatch: any) {
        simSwapResendOtp(hashCode, verification).then((response) => {
            dispatch({ type: SIMSwapOTPVerificationAction.SIMSWAP_OTP_RSEND_SUCCESS, payload: response });
        })
            .catch((error) => {
                //Display error
                if (error?.response) {
                    dispatch({ type: SIMSwapOTPVerificationAction.SIMSWAP_OTP_RSEND_SUCCESS, payload: error?.response });
                } else {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                }
            })
    }
}

export { SIMSwapOTPVerificationAction, OTPVerificationValue, OTPInitiate, OTPValidate, OTPResend };